import { RouteInferenceLegExplanation } from '@lune-climate/lune'
import { BannerMessage, Text } from '@lune-fe/lune-ui-lib'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'

import { getInferenceMessage } from './utils/logisticsUtils'

export const InferredShippingLegBanner = ({
    routeInferenceExplanation,
}: {
    routeInferenceExplanation: RouteInferenceLegExplanation | undefined | null
}) => {
    return getInferenceMessage(routeInferenceExplanation?.inferenceExplanation ?? null)
        .map((message) => (
            // eslint-disable-next-line react/jsx-key -- Option.map, not Array.map
            <BannerMessage sx={{ backgroundColor: 'white', mb: 2 }}>
                <AutoAwesomeOutlinedIcon sx={{ mr: 1, color: 'Blue400' }} />
                <Text sx={{ fontStyle: 'italic' }} variant="body3">
                    {message}
                </Text>
            </BannerMessage>
        ))
        .unwrapOr(<></>)
}

export default InferredShippingLegBanner
